import {FC, useEffect, useState} from 'react'
import {gameMenus} from "../../constants/game";
import {moneyFormatter} from "../../../_kiloit/helpers/components/MoneyUtils";
import {useAppSelector} from "../../redux/hooks/hook";
import {useBalance} from "../balance/action";
import {getLocalSt, stKeys} from "../../../_kiloit/helpers/storage";

const LobbyWrapper: FC = () => {
    const [active] = useState(0);
    const bl = useAppSelector(state => state.balance.balance);
    const {fetchBalance} = useBalance();

    useEffect(() => {
        fetchBalance();
        /*eslint-disable-next-line react-hooks/exhaustive-deps*/
    }, []);

    return (
        <div className="game-lobby-wrapper">
            <div className="lobby-header">
                <a href={getLocalSt(stKeys.redirectUrl)} className="btn-back">{""}</a>
                <div className="header-balance">
                    {moneyFormatter(bl.balance, bl.currencyCode)}
                </div>
            </div>
            {/*<div className="list-type-game">*/}
            {/*    <ul className="content-options">*/}
            {/*        {gameMenus.map((e, i) => {*/}
            {/*            return <li key={i} onClick={() => setActive(i)} className="cursor-pointer">*/}
            {/*                <div className={clsx("game-type border_cd", active === i ? "on" : "")}>*/}
            {/*                    <div className={clsx("menu-img", e.icon)}></div>*/}
            {/*                    <span className="t-cd">{e.name}</span>*/}
            {/*                </div>*/}
            {/*            </li>*/}
            {/*        })}*/}
            {/*    </ul>*/}
            {/*</div>*/}
            {gameMenus.map((e, i) => {
                return <div key={i}
                            className={`${i === active ? "d-block" : "d-none"}`}>
                    <e.component/>
                </div>;
            })}
        </div>
    )
}

export {LobbyWrapper}
